<template>
  <div class="aircrafts">
    <toolbar
      backRoute="/dashboard"
      title="Aircrafts"
      :addButton="true"
      addButtonLabel="Add aircraft"
      addButtonRoute="/dashboard/aircrafts/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search aircrafs"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="regin_mark" view="aircrafts" :column="orderColumn" :direction="orderDirection">Regn mark</sortable-table-heading>
          <sortable-table-heading field="icao_type" view="aircrafts" :column="orderColumn" :direction="orderDirection">ICAO type</sortable-table-heading>
          <sortable-table-heading field="mtow" view="aircrafts" :column="orderColumn" :direction="orderDirection">MTOW (kg)</sortable-table-heading>
          <sortable-table-heading field="seats" view="aircrafts" :column="orderColumn" :direction="orderDirection">Seats</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="5"
            class="text-center">
            Loading aircrafts&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && aircrafts.length === 0">
            <td
              colspan="5"
              class="text-center">
              There are no aircrafts to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(aircraft, index) of aircrafts"
          :key="'aircraft-' + index">
          <td class="align-middle">
            <span v-if="aircraft.is_archive">
              {{ aircraft.regin_mark }}
              <d-badge
                theme="dark"
                class="ml-2">
                archived
              </d-badge>
            </span>
            <span v-else>
              {{ aircraft.regin_mark }}
            </span>
          </td>
          <td class="align-middle" style="width: 160px;">{{ aircraft.icao_type }}</td>
          <td class="align-middle" style="width: 180px;">{{ aircraft.mtow }}</td>
          <td class="align-middle" style="width: 160px;">{{ aircraft.seats }}</td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/aircrafts/' + aircraft.id)"
              class="mr-2"
              title="Edit aircraft">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeAircraft(aircraft.id)"
              title="Remove aircraft">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'aircrafts',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      aircrafts: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeAircraft (aircraftID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/aircrafts/delete/',
        id: aircraftID,
        successTitle: 'Aircraft removed',
        successText: 'The selected aircraft has been removed',
        confirmTitle: 'Do you really want to remove this aircraft?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('calendar-aircrafts-update');
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
